import { atom, useAtom, useSetAtom } from "jotai";

export const enableAtom = atom<boolean>(true);

const useEnabledWindowReload = () => {
  const atom = useAtom(enableAtom);
  return atom;
};

export const useSetEnabledWindowReload = () => useSetAtom(enableAtom);

export default useEnabledWindowReload;
